module.exports = __webpack_public_path__ + "media/images/riders/small/TAHNEE_SEAGRAVE-dc455b9d9f1f21d10120dadd4c0ccfcc.png";